// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Belt_Result = require("bs-platform/lib/js/belt_Result.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");

function makeError(message, value) {
  return {
          path: "",
          message: message,
          value: value
        };
}

function note(v, error) {
  if (v !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: Caml_option.valFromOption(v)
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: error
          };
  }
}

function sequence(xs) {
  if (!xs) {
    return /* [] */0;
  }
  var x = xs.hd;
  if (x === undefined) {
    return ;
  }
  var x$1 = Caml_option.valFromOption(x);
  return Belt_Option.map(sequence(xs.tl), (function (rest) {
                return Belt_List.add(rest, x$1);
              }));
}

function sequenceR(xs) {
  if (!xs) {
    return {
            TAG: /* Ok */0,
            _0: /* [] */0
          };
  }
  var v = xs.hd;
  if (v.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: v._0
          };
  }
  var v$1 = v._0;
  return Belt_Result.map(sequenceR(xs.tl), (function (rest) {
                return Belt_List.add(rest, v$1);
              }));
}

function decodeSingleKeyDict(dict) {
  var match = Js_dict.entries(dict);
  if (match.length !== 1) {
    return ;
  }
  var match$1 = match[0];
  return [
          match$1[0],
          match$1[1]
        ];
}

function addJsonKey(key, value, dict) {
  return Js_dict.fromArray([[
                  key,
                  value
                ]].concat(Js_dict.entries(dict)));
}

function decodeDictName(jsonObject) {
  return Belt_Option.flatMap(Js_json.decodeObject(jsonObject), (function (dict) {
                return sequence(Belt_List.map(Belt_List.fromArray(Js_dict.entries(dict)), (function (param) {
                                  var name = param[0];
                                  return Belt_Option.flatMap(Js_json.decodeObject(param[1]), (function (attrs) {
                                                return Caml_option.some(addJsonKey("name", name, attrs));
                                              }));
                                })));
              }));
}

function dictFilter(dict, f) {
  return Js_dict.fromArray(Belt_Array.keep(Js_dict.entries(dict), f));
}

function dictKeyFilter(dict, f) {
  return dictFilter(dict, (function (param) {
                return Curry._1(f, param[0]);
              }));
}

function dictValueFilter(dict, f) {
  return dictFilter(dict, (function (param) {
                return Curry._1(f, param[1]);
              }));
}

function isNull(v) {
  var match = Js_json.classify(v);
  if (typeof match === "number") {
    return match >= 2;
  } else {
    return false;
  }
}

function dictGetString(dict, k) {
  return Belt_Option.flatMap(Js_dict.get(dict, k), Js_json.decodeString);
}

function encodeDictName(jsonObject) {
  return Belt_Option.flatMap(Js_json.decodeObject(jsonObject), (function (dict) {
                return Belt_Option.flatMap(dictGetString(dict, "name"), (function (name) {
                              return Caml_option.some(Js_dict.fromList({
                                              hd: [
                                                name,
                                                dictValueFilter(dictKeyFilter(dict, (function (k) {
                                                            return k !== "name";
                                                          })), (function (v) {
                                                        return !isNull(v);
                                                      }))
                                              ],
                                              tl: /* [] */0
                                            }));
                            }));
              }));
}

function decodeOneDictName(jsonObject) {
  var match = decodeDictName(jsonObject);
  if (match !== undefined && match && !match.tl) {
    return Caml_option.some(match.hd);
  }
  
}

exports.makeError = makeError;
exports.note = note;
exports.sequence = sequence;
exports.sequenceR = sequenceR;
exports.decodeSingleKeyDict = decodeSingleKeyDict;
exports.addJsonKey = addJsonKey;
exports.decodeDictName = decodeDictName;
exports.dictFilter = dictFilter;
exports.dictKeyFilter = dictKeyFilter;
exports.dictValueFilter = dictValueFilter;
exports.isNull = isNull;
exports.dictGetString = dictGetString;
exports.encodeDictName = encodeDictName;
exports.decodeOneDictName = decodeOneDictName;
/* No side effect */
